'use strict'

import Vue from 'vue'
import Vuex from 'vuex'

// The store modules.
import betting from './modules/betting'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

const createLocalStoragePlugin = store => {
  store.subscribe((mutation, { betting }) => {
    window.localStorage.setItem('lotto-stakes', JSON.stringify(betting.stakes))
  })
}
const plugins = [createLocalStoragePlugin]

export default new Vuex.Store({
  modules: {
    betting: {
      namespaced: true,
      ...betting
    }
  },
  strict: debug,
  plugins: plugins
})



// WEBPACK FOOTER //
// ./resources/assets/js/lotto/store/index.js